module.exports = __webpack_public_path__ + "static/media/hospital_2.0930a13a.svg";